import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Holder = styled.div`
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  height: 0;
  padding-bottom: 90%;
  border-radius: 50%;
  background-color: ${props => props.theme.colours.lightGrey2};
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

class Image extends Component {

  render() {
    return (
      <Holder>
        <img src={this.props.source} alt="Avatar"/>
      </Holder>
    )
  }
}

Image.propTypes = {
  source: PropTypes.string.isRequired
};

export default Image;
